// @ngInject
function TimeStampingApiService($q, $window, $http, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'usertimestamps';

    return {
        stampIn: stampIn,
        stampOut: stampOut,
        getLatestTimeStamps: getLatestTimeStamps,
        getTimeStampingUsers: getTimeStampingUsers,
        getLatestTimeStampDays: getLatestTimeStampDays,
        updateTimeStampDay: updateTimeStampDay,
        getNotificationMarkedTimeStampDays: getNotificationMarkedTimeStampDays,
        getTimeStampDaysInDateRange: getTimeStampDaysInDateRange,
        getTimeStampDayById: getTimeStampDayById,
        deleteTimeStamp: deleteTimeStamp,
        attestTimeStampDays: attestTimeStampDays,
        unattestTimeStampDays: unattestTimeStampDays,
        getWorkingTime: getWorkingTime,
        getTimeReports: getTimeReports,
        updateTimeReport: updateTimeReport,
        createTimeReport: createTimeReport,
        downloadExcelFile: downloadExcelFile,
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getLocation: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getUser: ResourcesService.apiFactory.get(endpoint + '/users'),
        getMe: ResourcesService.apiFactory.get(endpoint + '/me')
    };

    function stampIn(requestData) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'usertimestamps/stampin', requestData).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function stampOut(requestData) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'usertimestamps/stampout', requestData).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getLatestTimeStamps(numberOfTimeStamps) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/latest/' + numberOfTimeStamps).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getTimeStampingUsers(startDate, endDate, locationId, page, pageSize, searchTerms) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(searchTerms)) {
            params.searchTerm = searchTerms;
        }

        params.locationId = locationId;
        params.startDate = startDate;
        params.endDate = endDate;

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/users', {params: params}).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getLatestTimeStampDays(numberOfTimeStampDays) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/days/latest/' + numberOfTimeStampDays).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateTimeStampDay(timeStampDay) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'usertimestamps/days/', timeStampDay).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getNotificationMarkedTimeStampDays(userId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/days/notifications/user/' + userId).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getTimeStampDaysInDateRange(userId, startDate, endDate, location) {
        var deferred = $q.defer();

        var locationId = location.id;

        var dateRange = {
            startDate: startDate,
            endDate: endDate
        };

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/days/range/users/' + userId + '/locations/' + locationId, {params: dateRange}).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getTimeStampDayById(timeStampDayId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/days/' + timeStampDayId).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteTimeStamp(timeStampId) {
        var deferred = $q.defer();

        DSHttpAdapter.DEL(DS.defaults.basePath + 'usertimestamps/' + timeStampId).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function attestTimeStampDays(timeStampIds) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'usertimestamps/days/attest', timeStampIds).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function unattestTimeStampDays(timeStampIds) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'usertimestamps/days/unattest', timeStampIds).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getWorkingTime(startDate, endDate) {
        var deferred = $q.defer();

        var params = {
            startDate: startDate,
            endDate: endDate
        };

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/workedtime', {params: params}).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getTimeReports(startDate, endDate, userId) {
        var deferred = $q.defer();

        var params = {
            startDate: startDate,
            endDate: endDate
        };

        DSHttpAdapter.GET(DS.defaults.basePath + 'usertimestamps/reports/user/' + userId, {params: params}).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateTimeReport(timeReport) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'usertimestamps/timereport', timeReport).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createTimeReport(timeReport) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'usertimestamps/timereport', timeReport).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadExcelFile(request) {
        var url = $window.URL || $window.webkitURL;

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'usertimestamps/excelprint', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, "time.xlsx");
            } else {
                var downloadUrl = url.createObjectURL(blob);
                $window.location = downloadUrl;
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('timestamping.api', [])
    .factory('TimeStampingApiService', TimeStampingApiService);
